<script>
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import StoreCardMixin from '@phoenix/mixins/components/store/storeCardMixin';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PictureLazy,
    PhxIcon,
  },

  mixins: [StoreCardMixin],

  props: {
    services: {
      type: Array,
      default: () => [],
    },
    status: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    tagClasses() {
      return ['h6', 'boutique-card__pretitle', { 'boutique-card__pretitle--discrete': this.isReseller }];
    },

    tagText() {
      if (this.isRepairer) {
        return this.$t('Store.repairer');
      }

      return this.$t(this.isReseller ? 'Store.reseller' : 'Store.boutique');
    },

    hasServices() {
      return this.services.length > 0;
    },

    cardClasses() {
      return ['boutique-card', { 'boutique-card--with-picture': this.image }];
    },

    statusClasses() {
      return [
        'tag',
        'boutique-card__status',
        {
          'tag--paladium': this.status?.status === 'open',
          'boutique-card__status--closed': this.status?.status !== 'open',
        },
      ];
    },
  },
};
</script>

<template>
  <div :class="cardClasses">
    <div v-if="image" class="boutique-card__picture">
      <div class="picture picture--cover">
        <picture-lazy v-bind="image" />
      </div>
    </div>

    <div class="boutique-card__body">
      <div class="boutique-card__body--top">
        <div :class="tagClasses">{{ tagText }}</div>

        <span v-if="status" :class="statusClasses">{{ status.label }}</span>

        <h4 class="boutique-card__title">{{ title }}</h4>

        <address class="boutique-card__address" v-html="address" />

        <div v-if="hasServices" class="boutique-card__services">
          <span v-for="(service, index) in services" :key="index" class="tag boutique-card__service">
            {{ $t(`Store.services.${service}`) }}
          </span>
        </div>
      </div>

      <div v-if="phone || permalink" class="boutique-card__body--bottom">
        <div class="boutique-card__actions">
          <a
            v-if="phone"
            :href="`tel:${phone.replace(/\s/g, '')}`"
            class="btn btn--default btn--sm btn--full btn--icon btn--negative"
          >
            <span class="btn__text">{{ phoneLabel || phone }}</span>

            <span class="btn__icon">
              <phx-icon icon="phone-16" />
            </span>
          </a>

          <a
            v-if="permalink"
            :href="permalink"
            :target="isOnline ? '_blank' : null"
            :data-tracking="dataTracking ? JSON.stringify(dataTracking) : null"
            :aria-label="title"
            class="btn btn--default btn--sm btn--full btn--icon"
          >
            <span class="btn__text">{{ seeMoreLabel }}</span>

            <span class="btn__icon">
              <phx-icon icon="info-16" />
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
